import { createActionTypes } from "@src/utility"

export const LOGIN_TYPES = createActionTypes("LOGIN", [
  "REQUEST",
  "SUCCESS",
  "FAILURE",
  "LOGOUT",
  "CLEAR_ERROR",
  "AZURE_SSO_REQUEST",
  "AZURE_SSO_SUCCESS",
  "AZURE_SSO_FAILURE"
])
